import { Children } from 'react';
import type { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './_index.module.scss';

export interface FloatingToolbarProps extends HTMLAttributes<HTMLDivElement> {
  'data-testid'?: string;
}

const FloatingToolbar = ({
  'aria-label': ariaLabel,
  children,
  className,
  'data-testid': dataTestId = 'floating-toolbar',
  ...rest
}: FloatingToolbarProps) => {
  const hasChildren = Children.count(children) > 0;
  if (!hasChildren) return null;

  return (
    <div
      {...rest}
      aria-label={ariaLabel || 'Floating toolbar'}
      className={classNames(styles['floating-toolbar-container'], className)}
      data-testid={dataTestId}
      role="region"
    >
      <div
        aria-label={ariaLabel ? ariaLabel : 'Floating toolbar actions'}
        className={styles['floating-toolbar']}
        role="toolbar"
      >
        {children}
      </div>
    </div>
  );
};

export default FloatingToolbar;
